<template>
  <div class="row m-0">
    <div class="col-12">
      <h1 class="title font-weight-bold text-uppercase">
        PAGAMENTO PACOTE DE ARTES PARA REDES SOCIAIS - VIA CARTÃO DE CRÉDITO.
      </h1>
      <hr class="linha-amarela" />
    </div>
      <div class="col-6 formatCardCenter">
        <div class="card-wrapper mb-5"></div>
      </div>
      <div id="cc-form" class="col-6 mb-3">
        <div class="row">
          <div class="col-12">
            <label for="email">Número cartão</label>
            <input
              class="form-control mb-3"
              id="cc-number"
              type="text"
              name="number"
              v-model="number"
              placeholder="xxxx - xxxx - xxxx - xxxx"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label for="email">Primeiro nome</label>
            <input
              class="form-control mb-3"
              id="ccName"
              type="text"
              name="ccName"
              v-model="ccName"
              placeholder="Digite o seu nome"
            />
          </div>
          <div class="col-6">
            <label for="email">Último nome</label>
            <input
              class="form-control mb-3"
              id="last-name"
              type="text"
              name="last-name"
              v-model="lastname"
              placeholder="Digite o seu sobrenome"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <label for="email">Mês de expiração do cartão</label>
            <input
              class="form-control mb-3"
              id="cc-expiration"
              type="text"
              name="expiry"
              v-model="month"
              placeholder="xx"
               maxlength="2"
            />
          </div>
          <div class="col-4">
            <label for="email">Ano de expiração do cartão</label>
            <input
              class="form-control mb-3"
              id="cc-expiration"
              type="text"
              name="expiry"
              v-model="year"
              placeholder="xxxx"
              maxlength="4"
            />
          </div>
          <div class="col-4">
            <label for="email">CVV/CVC</label>
            <input
              class="form-control mb-3"
              id="cc-cvv"
              type="text"
              name="cvc"
              v-model="cvv"
              placeholder="xxx"
              maxlength="4"
              @focus="validCVC('back')"
              @blur="validCVC('front')"
            />
          </div>
        </div>
        <button @click="submitCC()" class="mt-3 btn btn-success btn-block">Realizar pagamento</button>
      </div>
  </div>
</template>

<script type="text/javascript" src="https://js.iugu.com/v2"></script>
<script>
import * as Card from 'card';
import { mapState } from 'vuex';
import makeToast from '../../mixins/makeToast';

export default {
  name: 'credit-card',
  data() {
    return {
      id: null,
      number: '',
      ccName: '',
      lastname: '',
      month: '',
      year: '',
      cvv: '',
      valid: false,
      classCard: ''
    };
  },
  mixins: [makeToast],
  computed: {
    ...mapState({
      dadosUsuario: (state) => state.dadosUsuario
    }),
  },
  watch: {
    'ccName': function () {
      const name = document.querySelectorAll('.jp-card-name')
      const nameFull = this.ccName +' '+ this.lastname
      name[0].innerText = nameFull
    },
    'lastname': function () {
      const name = document.querySelectorAll('.jp-card-name')
      const nameFull = this.ccName +' '+ this.lastname
      name[0].innerText = nameFull
    },
    'month': function () {
      const cardExpiry = document.querySelectorAll('.jp-card-expiry')
      const cardFull = this.month +'/'+ this.year
      cardExpiry[0].innerText = cardFull
    },
    'year': function () {
      const cardExpiry = document.querySelectorAll('.jp-card-expiry')
      const cardFull = this.month +'/'+ this.year
      cardExpiry[0].innerText = cardFull
    },
    'cvv': function () {
      const cvv = document.querySelectorAll('.jp-card-cvc')
      console.log(cvv)
      cvv[1].innerText = this.cvv
    }
  },
  mounted() {
    this.id = this.$route.params.id
    let Script = document.createElement('script');
    Script.setAttribute('src', 'https://js.iugu.com/v2');
    document.head.appendChild(Script);

    // eslint-disable-next-line no-new
    new Card({
      form: 'div#cc-form',
      container: '.card-wrapper',
      formSelectors: {
        numberInput: 'input#cc-number',
        nameInput: 'input#ccName',
        expiryInput: 'input#cc-month, input#cc-year',
        cvcInput: 'input#cc-cvv',
      },
      width: 370,
      formatting: true,
      messages: {
        validDate: 'valido\ndata',
        monthYear: 'mm/yyyy',
      },
      placeholders: {
        number: '•••• •••• •••• ••••',
        name: 'Nome completo',
        expiry: '••/••',
        cvc: '•••',
      },
    });
  },
  methods: {
    submitCC() {
      this.validPayment();
      if(this.valid == false) {
        return;
      }

      this.$store.dispatch('startLoader');
      Iugu.setAccountID('D9BC3DAFD6314DE2B01323646B94F29B');
      Iugu.setup();
      Iugu.setTestMode(false);
      const cc = Iugu.CreditCard(
        this.number,
        this.month,
        this.year,
        this.ccName,
        this.lastname,
        this.cvv
      );
      Iugu.createPaymentToken(cc, (response) => {
        if (response.errors) {
          this.$store.dispatch('endLoader');
          this.makeToast('Oops!', 'Não foi possível salvar o cartão', 'danger');
        } else {
          const data = {
            id: this.id,
            token: response.id
          };

          this.$store.dispatch('shopkeeper/efetuarPagamento', data)
          .then((resp) => {
            if(resp.data.message == 'success') {
              this.makeToast('Sucesso', 'Plano contratado com sucesso', 'success');
              this.$router.push({ name: 'lojista-artes-redes-sociais'});
            } else {
              this.makeToast('Oops!', 'Não foi possível realizar o pagamento', 'danger');
            }
          })
          .catch(() => {
            this.makeToast('Oops!', 'Não foi possível realizar o pagamento', 'danger');
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          })
        }
      });
    },
    validCVC(type) {
      const front = document.querySelectorAll('.jp-card')
      if (type == 'back') {
        this.classCard = front[0].className;
        front[0].className = 'jp-card jp-card-flipped';
      }
      if (type == 'front') {
        front[0].className = this.classCard;
      }
    },

    validPayment() {
      this.valid = true;
      if(this.number == '') {
        this.makeToast('Oops!',
          'Preencha o número do seu cartão!',
          'danger');
          this.valid = false;
      }
      if(this.ccName == '') {
        this.makeToast('Oops!',
          'Informe seu nome!',
          'danger');
          this.valid = false;
      }
      if(this.lastname == '') {
        this.makeToast('Oops!',
          'Informe seu sobrenome!',
          'danger');
          this.valid = false;
      }
      if(this.month == '') {
        this.makeToast('Oops!',
          'Informe o mês da validade do seu cartão!',
          'danger');
          this.valid = false;
      }
      if(this.year == '') {
        this.makeToast('Oops!',
          'Informe o ano da validade do seu cartão!',
          'danger');
          this.valid = false;
      }
      if(this.cvv == '') {
        this.makeToast('Oops!',
          'Informe o cvv do seu cartão!',
          'danger');
          this.valid = false;
      }
    },
  },
};
</script>

<style scoped>
.color-success {
  color: rgb(237, 118, 70);
}
.formatCardCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>